import { useState } from "react";
import { Card, Input, Modal, Tabs, notification, Button } from "antd";
// import { QrcodeOutlined } from "@ant-design/icons";
// import { Link } from "react-router-dom";
import { marcarAsistencia } from "../../api/sistema";
import { useAuth } from "../../utils/useAuth";
import { Responder } from "../../components";
import Lista from "./Lista";
import AParticipante from "./AParticipante";
import ACarnetParticipante from "./ACarnetParticipante";
import AIngresante from "./AIngresante";
import * as SHARED from "../../utils/shared";

const { Search } = Input;
const { TabPane } = Tabs;

function SistemaHome() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isConsulting, setIsConsulting] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { usuario } = useAuth();

  const handleSearch = (value) => {
    if (!value.length) return null;

    setIsConsulting(true);
    const body = {
      dniregistrador: usuario.nrodocumento || "not found",
      codigoOrDNI: value,
      metodoregistro: "QR"
    };

    marcarAsistencia(body)
      .then((res) => {
        setIsModalVisible(true);
        setModalContent(<Responder response={res.payload} />);
      })
      .catch((err) => {
        notification.error({ description: err.message });
      })
      .finally(() => {
        setIsConsulting(false);
        setSearchValue("");
      });
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="p-4 mx-auto text-center w-full">
      <div className="">
        <p className="text-base font-bold">SISTEMA DE ASISTENCIA </p>
        <p className="text-base font-bold text-blue-500 uppercase my-2">{SHARED.PROCESO}</p>
      </div>

      <style>{`
        .ant-tabs-nav-operations {
          display: none !important;
        }
      `}</style>

      <div className="w-full">
        <Tabs tabPosition="top" tabBarStyle={{ textAlign: "center", margin: "auto" }} animated={false}>
          <TabPane tab="Postulante" key="1">
            <Card className="mt-8 px-2 rounded-lg bg-gray-100 max-w-sm mx-auto">
              <div className="font-semibold flex flex-col">
                <span className="mb-2 text-base">
                  Marcar asistencia por código ó QR de{" "}
                  <span className="text-red-500">POSTULANTE</span>
                </span>
                <Search
                  placeholder="ejem. 120010"
                  className="text-2xl"
                  type="number"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onSearch={handleSearch}
                  enterButton
                  loading={isConsulting}
                  allowClear
                  size="large"
                />
              </div>
            </Card>
            {/* <Link to="/sistema/qr">
              <Button type="link" icon={<QrcodeOutlined />} size="middle" className="my-10">
                Marcar mediante código QR
              </Button>
            </Link> */}
          </TabPane>

          <TabPane tab="Listado de asistencia" key="2">
            <Lista />
          </TabPane>
          <TabPane tab="Participante" key="3">
            <AParticipante />
          </TabPane>
          <TabPane tab="Carnet" key="4">
            <ACarnetParticipante />
          </TabPane>
          <TabPane tab="Form" key="5">
            <AIngresante />
          </TabPane>
        </Tabs>
      </div>

      <Modal
        visible={isModalVisible}
        closable
        onCancel={closeModal}
        destroyOnClose
        footer={
          <Button onClick={closeModal} block type="primary">
            Cerrar
          </Button>
        }
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </div>
  );
}
export default SistemaHome;

